'use strict';

/**
 * Appends params to a URL.
 * @param {string} url - Original URL.
 * @param {Object} params - Parameters to append.
 * @returns {string} Result URL with appended parameters.
 */
function appendToUrl(url, params) {
    let newUrl = url;
    if (params) {
        newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map((key) => `${key}=${encodeURIComponent(params[key])}`).join('&');
    }
    return newUrl;
}

/**
 * Gets the filters selected by the user.
 * @returns {Array|null} The selected values or null if none.
 */
function getActiveFilters() {
    const valuesSeleccionados = [];
    $('.js-filter-selectors select').each(function getFilterVal() {
        const value = $(this).val().trim();
        if (value.length > 0) {
            valuesSeleccionados.push(value);
        }
    });
    return valuesSeleccionados.length > 0 ? valuesSeleccionados : null;
}

/**
 * Gets the final URL with the sort option selected.
 * @param {string} endPoint - The endpoint URL.
 * @returns {string} The URL with sorting configuration.
 */
function getUrlWithSortConfig(endPoint) {
    let url = endPoint;
    const value = $('#sorting #sortingSelect').val().trim();
    if (value.length > 0) {
        const sortParams = {
            sortingType: decodeURIComponent(new URL(value).searchParams.get('sortingType'))
        };
        url = appendToUrl(url, sortParams);
    }
    return url;
}

const applyFilters = () => {
    const endPoint = getUrlWithSortConfig($('.js-filter-selectors').data('url'));
    const url = appendToUrl(endPoint, getActiveFilters());
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'GET',
        success: response => {
            $('.recipes-wrapper').empty().append(response);
            $('.total span').text($('.recipes-wrapper #totalRecipes').val());
        },
        complete: () => {
            $.spinner().stop();
        }
    });
};

$(() => {
    applyFilters();

    $('body').on('change', '#sortingSelect', (e) => {
        e.stopPropagation();
        e.preventDefault();
        const endPoint = $(e.currentTarget).val().trim();
        if (endPoint) {
            const url = appendToUrl(endPoint, getActiveFilters());
            $.spinner().start();
            $.ajax({
                url,
                method: 'GET',
                success: response => {
                    $('.recipes-wrapper').empty().append(response);
                    $('.total span').text($('.totalRecipes').val());
                },
                complete: () => {
                    $.spinner().stop();
                }
            });
        }
    });

    $('body').on('change', 'div.filteringSelect select', (e) => {
        e.stopPropagation();
        e.preventDefault();
        applyFilters();
    });

    $('.recipes-wrapper').on('click', 'button.js-page-nav', (e) => {
        e.stopPropagation();
        e.preventDefault();
        const endPoint = getUrlWithSortConfig($(e.currentTarget).data('url'));
        const url = appendToUrl(endPoint, getActiveFilters());
        $.spinner().start();
        $.ajax({
            url,
            method: 'GET',
            success: response => {
                $('.recipes-wrapper').empty().append(response);
            },
            complete: () => {
                $.spinner().stop();
                const $container = $('.recipes-wrapper');
                const scrollTop = $container.offset().top - 250;
                $('html, body').animate({ scrollTop }, 500, () => {
                    $container.focus();
                });
            }
        });
    });
});
